export enum MediaItemStyle {
  Tooltip = 'tooltip',
  Popup = 'popup'
}

export interface MediaItemProps {
  url: string;
  type?: MediaItemStyle;
  innerStyle?: Record<string, unknown>;
  settings?: {
    adminPanelAccess?: false;
  };
  inFullScreen: boolean;
  toggleFullScreen: any;
}
